import { createIcon } from '@chakra-ui/react';

export const TwitterIcon = createIcon({
  displayName: 'TwitterIcon',
  viewBox: '0 0 14 12',
  path: [
    <path
      key="1"
      d="M12.1691 3.23842C12.177 3.35776 12.177 3.47711 12.177 3.59755C12.177 7.26747 9.49411 11.5 4.58828 11.5V11.4978C3.13908 11.5 1.71999 11.0677 0.5 10.2527C0.710725 10.2791 0.922507 10.2923 1.13482 10.2928C2.33579 10.2939 3.50244 9.8743 4.44727 9.1016C3.30597 9.07905 2.30516 8.30415 1.95554 7.17287C2.35533 7.25317 2.76728 7.23667 3.15968 7.12503C1.9154 6.86324 1.02021 5.72481 1.02021 4.4027C1.02021 4.3906 1.02021 4.37905 1.02021 4.3675C1.39096 4.58254 1.80607 4.70188 2.23069 4.71508C1.05876 3.89948 0.697522 2.27598 1.40522 1.00666C2.75935 2.7418 4.75728 3.79664 6.90203 3.90828C6.68708 2.94364 6.98072 1.9328 7.67363 1.2547C8.74786 0.203163 10.4374 0.25706 11.4471 1.37514C12.0445 1.2525 12.617 1.02426 13.1409 0.700882C12.9418 1.34379 12.5251 1.88991 11.9684 2.23693C12.4971 2.17204 13.0136 2.02465 13.5 1.79971C13.1419 2.35848 12.6909 2.8452 12.1691 3.23842Z"
      fill="white"
    />
  ]
});
